module.exports = __webpack_public_path__ + "img/consult_info7.735b2d6e.png";